module.exports = __webpack_public_path__ + "img/play.da997873.png";